import { UPDATE_REPORT_FORMAT } from './format-picker-actions';

const initialState = {
    reportFormats: []
};

export default function(state = initialState, action) {
    if (!action) return state;

    switch (action.type) {
        case UPDATE_REPORT_FORMAT: {
            return {
                ...state,
                reportFormats: getUpdatedReportFormat(
                    state.reportFormats,
                    action.payload
                )
            };
        }
        default:
            return state;
    }
}

/**
 * Multiple report formats can be selected. If exists we remove... if not we append
 * @param currentReportFormat: state.reportFormats
 * @param payload: action.payload
 * @returns updated report formats array
 */
function getUpdatedReportFormat(currentReportFormat, payload) {
    const updatedReportFormat = [...currentReportFormat];

    if (currentReportFormat.includes(payload)) {
        return updatedReportFormat.filter((item) => item !== payload);
    }

    return [...updatedReportFormat, payload];
}



// WEBPACK FOOTER //
// ./components/sub-heading/format-picker/format-picker-reducer.js